module.exports = __webpack_public_path__ + "static/potted-plant-collection-coloring-page-a1ec601155c9ea824e7e7cc75c753703.pdf";